module.exports = __webpack_public_path__ + "img/avatar2.b28cea81.png";